import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { ButtonModule } from '@components/button';
import { ButtonCtaComponent } from '@components/button-cta/button-cta.component';
import { EventLoggerService } from '@services/event-logger-service';
import { ExperimentService } from '@services/experiment/experiment.service';

@Component({
  selector: 'share-payment-how-it-works',
  templateUrl: './share-payment-how-it-works.html',
  imports: [CommonModule, ButtonModule, ButtonCtaComponent],
})
export class SharePaymentHowItWorksComponent {
  data = inject<any>(MAT_BOTTOM_SHEET_DATA);
  private readonly bottomSheetRef = inject(MatBottomSheetRef);
  private readonly eventLogger = inject(EventLoggerService);
  private readonly experimentService = inject(ExperimentService);

  acqRebranding2025: boolean = false;
  isCCODEligible: boolean = false;
  orderSP: number = 0;

  ngOnInit(): void {
    this.acqRebranding2025 = this.experimentService.acqRebranding2025;
    this.isCCODEligible = this.data?.isCCODEligible ?? false;
    this.orderSP = this.data?.orderSP || 0;
    this.eventLogger.cleverTapEvent('pageOpen', JSON.stringify({ pageName: 'share_payment_how_it_works_shown' }));
  }

  onCtaClick(): void {
    if (this.isCCODEligible) {
      this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'generate_payment_link_clicked' }));
      this.bottomSheetRef.dismiss();
      if (this.data?.onGenerateLink) {
        this.data.onGenerateLink();
      }
    } else {
      this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'share_payment_link_direct_clicked' }));
      this.bottomSheetRef.dismiss();
      if (this.data?.onShareDirectly) {
        this.data.onShareDirectly();
      }
    }
  }

  closeBottomSheet(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'share_payment_how_it_works_closed' }));
    this.bottomSheetRef.dismiss();
  }
}
